import { PostTypes } from '../Home';

export interface SelectedPost {
  postId?: string;
  flowId?: string;
  type?: PostTypes;
  commentId?: string;
  responseId?: string;
}

export interface LayoutStyleProps {
  isActive?: boolean;
  isMobileApp?: boolean;
  showRightAside?: boolean;
  isEmbeddedInMainApp?: boolean;
  hasFlowBuilderTabs?: boolean;
  isRewardsPage?: boolean;
  isLeftAsideOpen?: boolean;
  isRightAsideOpen?: boolean;
  hasAdminOption?: boolean;
  background?: string;
  hasTabComponent?: boolean;
  removeMargin?: boolean;
  isHovered?: boolean;
  isKioskTurnedOn?: boolean;
  isResizable?: boolean;
  width?: number;
  hasRightMargin?: boolean;
  overflow?: string;
  isFullScreen?: boolean;
  hasBorderBottom?: boolean;
  leftMargin?: string;
  isMobileAppV3?: boolean;
}

export enum SecondaryPanel {
  ASSEMBLY = 'assembly',
  NOTIFICATIONS = 'notifications',
  PROFILE = 'profile',
  QUICK_SETUP = 'quick-setup',
  REWARDS = 'rewards',
}

export interface SelectedMember {
  firstName?: string;
  memberId: string;
}

export type LayoutStoreState = {
  showChats: boolean;
  showReplies: boolean;
  showRightAside: boolean;
  rightAsideWidth: number;
  isLeftAsideOpen: boolean;
  isRightAsideOpen: boolean;
  isLeftNavHovered: boolean;
  selectedPost: SelectedPost;
  isEmbeddedInMainApp: boolean;
  activeNavItem: SecondaryPanel;
  activeSecondaryPanel: SecondaryPanel;
  toggleLeftAsideOpen: () => void;
  toggleRightAsideOpen: () => void;
  toggleShowRightAside: () => void;
  setLeftAsideOpenToTrue: () => void;
  setLeftAsideOpenToFalse: () => void;
  setRightAsideOpenToTrue: () => void;
  setRightAsideOpenToFalse: () => void;
  setShowRightAsideToTrue: () => void;
  setShowRightAsideToFalse: () => void;
  closeRightSideBarForMobile: () => void;
  setLeftNavHoveredToTrue: () => void;
  setLeftNavHoveredToFalse: () => void;
  setShowChats: (show: boolean) => void;
  setShowReplies: (show: boolean) => void;
  setRightAsideWidth: (width: number) => void;
  setSelectedPost: (post: SelectedPost) => void;
  enableEmbeddedModeInMainApp: () => void;
  setActiveNavItem: (navItem: SecondaryPanel) => void;
  setActiveSecondaryPanel: (navItem: SecondaryPanel) => void;
  selectedMember?: SelectedMember;
  setSelectedMember: (selectedMember: SelectedMember) => void;
  setMemberAndToggleRightAsideOpen: (selectedMember: SelectedMember) => void;
  removeSelectedMember: () => void;
  taskIdForNotebook: string;
  setTaskIdForNotebook: (taskId: string) => void;
};
